import React, { useContext } from "react";
import { IconButton, Menu, MenuItem, Avatar } from "@mui/material";
import { UserItem } from "../../api/models/schema";
import { useNavigate } from "react-router-dom";
import { AppUserContext } from "../../context/appUserContext";



export interface LogoutButtonProps {
  user: UserItem;
}

export function LogoutButton(props: LogoutButtonProps) {

  const navigate = useNavigate();

  const {refreshUser } = useContext(AppUserContext);

  const initials = `${props.user.firstName?.charAt(0)}${props.user.lastName?.charAt(0)}`.toUpperCase();

  function logout() {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    refreshUser();
    navigate("/login");
  }

  const [profileMenu, setProfileMenu] = React.useState<Element | null>(null);

  return (
    <div>
      <IconButton onClick={(e) => setProfileMenu(e.currentTarget as Element)}>
        <Avatar
          style={{
            margin: "10px",
            width: "60px",
            height: "60px",
            backgroundColor: props.user?.isSuperAdmin ? "red" : "blue",

          }}
        >{initials}</Avatar>
      </IconButton>

      <Menu
        id="profile-menu"
        open={Boolean(profileMenu)}
        anchorEl={profileMenu}
        onClose={() => setProfileMenu(null)}
        disableAutoFocusItem
      >
        <MenuItem onClick={() => logout()}>LogOut</MenuItem>
      </Menu>
    </div>
  );
}
